import { useQuery } from '@tanstack/react-query';

import { getValidStates } from 'api/address';

export const getValidStatesQueryKey = ['get-valid-states'];

export const useValidStatesQuery = (overrides = {}) =>
  useQuery({
    queryKey: getValidStatesQueryKey,
    queryFn: getValidStates,
    ...overrides,
  });
